import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
export function HcpSignalsSlide({
  onNext,
  onBack
}: {
  onNext: () => void;
  onBack: () => void;
}) {
  const patients = [{
    id: 'A',
    symptom: 'Lump',
    duration: '6 weeks',
    change: 'Growing',
    color: 'rose'
  }, {
    id: 'B',
    symptom: 'Pain',
    duration: '2 weeks',
    change: 'Stable',
    color: 'amber'
  }, {
    id: 'C',
    symptom: 'Lump',
    prevImaging: 'Yes',
    color: 'rose'
  }];
  return <div className="flex flex-col h-full px-6 py-8 relative z-10 bg-slate-950 text-slate-300" data-id="element-305">
      <div className="flex items-center justify-between mb-6" data-id="element-306">
        <button onClick={onBack} className="p-2 -ml-2 text-slate-400 hover:text-white transition-colors bg-slate-900 rounded-full shadow-sm border border-slate-800" aria-label="Go back" data-id="element-307">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-308" />
        </button>
      </div>

      <div className="flex-1 flex flex-col max-w-sm mx-auto w-full overflow-y-auto no-scrollbar pb-20" data-id="element-309">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8" data-id="element-310">
          <h2 className="text-2xl font-semibold text-white leading-tight mb-4" data-id="element-311">
            Patient intake reveals structured clinical signals
          </h2>

          <p className="text-slate-400 leading-relaxed" data-id="element-312">
            Instead of reading referral text, the clinic can receive structured
            patient responses before the appointment.
          </p>
        </motion.div>

        <div className="space-y-3 mb-8 relative" data-id="element-313">
          {patients.map((p, i) => <motion.div key={p.id} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + i * 0.15,
          type: 'spring',
          stiffness: 100
        }} className="bg-slate-900 border border-slate-800 rounded-xl p-4 shadow-sm relative overflow-hidden" data-id="element-314">
              <div className={`absolute left-0 top-0 bottom-0 w-1 bg-${p.color}-500`} data-id="element-315" />
              <div className="flex justify-between items-start mb-2" data-id="element-316">
                <span className="text-white font-medium text-sm" data-id="element-317">
                  Patient {p.id}
                </span>
                <span className={`text-${p.color}-400 text-xs font-bold bg-${p.color}-500/10 px-2 py-0.5 rounded`} data-id="element-318">
                  {p.symptom}
                </span>
              </div>
              <div className="flex space-x-4 text-xs text-slate-400" data-id="element-319">
                {p.duration && <div data-id="element-320">
                    Duration:{' '}
                    <span className="text-slate-300" data-id="element-321">{p.duration}</span>
                  </div>}
                {p.change && <div data-id="element-322">
                    Change: <span className="text-slate-300" data-id="element-323">{p.change}</span>
                  </div>}
                {p.prevImaging && <div data-id="element-324">
                    Previous imaging:{' '}
                    <span className="text-slate-300" data-id="element-325">{p.prevImaging}</span>
                  </div>}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="bg-slate-800/50 border border-slate-700/50 p-4 rounded-xl" data-id="element-326">
          <p className="text-sm text-slate-400 leading-relaxed text-center" data-id="element-327">
            Structured responses help the clinic prepare before the visit.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1
    }} className="absolute bottom-6 left-6 right-6" data-id="element-328">
        <button onClick={onNext} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors shadow-lg shadow-nhs-blue/20 active:scale-[0.98] group" data-id="element-329">
          See clinic grouping
          <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-330" />
        </button>
      </motion.div>
    </div>;
}